import React from 'react';
import { ServiceManifestDataForm } from '../../../../app/models/ServiceManifest';
import { ExchangeRateDateEnum } from '../../../../app/shared/enums';

interface Props {
  serviceManifestDataForm: ServiceManifestDataForm;
}

const ServiceManifestInvoicingShowForm: React.FC<Props> = ({ serviceManifestDataForm }) => {
  if (!serviceManifestDataForm) return null;

  const {
    payment_method,
    currency,
    payment_condition,
    days_count,
    exchange_rate_date_value,
    fixed_date,
    final_days,
    final_months,
    final_year
  } = serviceManifestDataForm;

  const exchangeDateId = exchange_rate_date_value?.id;
  // Solo FECHA_FIJA muestra la fecha fija;
  // cualquier otro (FECHA_FACTURA, ULTIMO_DIA_MES_ENTREGA) muestra días/meses/año
  const isFixed = exchangeDateId === ExchangeRateDateEnum.FECHA_FIJA;

  return (
    <>
      {/* Datos generales */}
      <div className="mb-2 row">
        <div className="col-md-6">
          <label className="col-form-label">Forma de pago</label>
          <input
            type="text"
            className="form-control bg-light"
            value={payment_method || ''}
            readOnly
          />
        </div>
        <div className="col-md-6">
          <label className="col-form-label">Moneda</label>
          <input
            type="text"
            className="form-control bg-light"
            value={currency || ''}
            readOnly
          />
        </div>
      </div>

      <div className="mb-2 row">
        <div className="col-md-6">
          <label className="col-form-label">Condición de pago</label>
          <input
            type="text"
            className="form-control bg-light"
            value={payment_condition || ''}
            readOnly
          />
        </div>
        <div className="col-md-6">
          <label className="col-form-label">Cantidad de días</label>
          <input
            type="text"
            className="form-control bg-light"
            value={days_count?.toString() || ''}
            readOnly
          />
        </div>
      </div>

      {/* Fecha tipo de cambio */}
      <div className="mb-2 row">
        <div className="col-md-6">
          <label className="col-form-label">Fecha tipo de cambio</label>
          <input
            type="text"
            className="form-control bg-light"
            value={exchange_rate_date_value?.name || ''}
            readOnly
          />
        </div>
      </div>

      {isFixed ? (
        // Modo fecha fija
        <div className="mb-2 row">
          <div className="col-md-6">
            <label className="col-form-label">Fecha fija</label>
            <input
              type="date"
              className="form-control bg-light"
              value={fixed_date || ''}
              readOnly
            />
          </div>
        </div>
      ) : (
        // Modo numérico (FECHA_FACTURA o ULTIMO_DIA_MES_ENTREGA)
        <div className="mb-2 row">
          <div className="col-md-3">
            <label className="col-form-label">Días</label>
            <input
              type="number"
              className="form-control bg-light"
              value={final_days?.toString() || ''}
              readOnly
            />
          </div>
          <div className="col-md-3">
            <label className="col-form-label">Meses</label>
            <input
              type="number"
              className="form-control bg-light"
              value={final_months?.toString() || ''}
              readOnly
            />
          </div>
          <div className="col-md-3">
            <label className="col-form-label">Año</label>
            <input
              type="number"
              className="form-control bg-light"
              value={final_year?.toString() || ''}
              readOnly
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ServiceManifestInvoicingShowForm;
